import { Button, message, Modal, Switch, Typography } from 'antd'
import styled from 'styled-components'
import { IconFont, SignTitle, UpLoadFile } from '@/components'
import { useState } from 'react'
import { Message } from '@/components/message'
import { t } from '@/i18n'

export const BatchAddModal = props => {
  const { id, closeModal, visible } = props
  // const [updata, setUpdata] = useState<any>(id)
  const [err, setErr] = useState(false)
  let userData
  try {
    userData = JSON.parse(localStorage.getItem('token'))
  } catch (error) {}
  const [uploadCsvLoading, setUploadCsvLoading] = useState(false)
  const [uploadSuccess, setUploadSuccess] = useState(false)
  const [dataList, setDataList] = useState({})
  const [switchVal, setSwitchVal] = useState(true)

  const tableToExcel = () => {
    // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
    let str = t('用例名称,Email,dept_name,tags\n')
    // 增加\t为了不让表格显示科学计数法或者其他格式
    for (let i = 0; i < dataList?.err?.length; i++) {
      str += `${`${dataList?.err[i].name || ''}\t`},`
      str += `${`${dataList?.err[i].email || ''}\t`},`
      str += `${`${dataList?.err[i].group_name || ''}\t`},`
      str += `${`${dataList?.err[i].tags?.join(';') || ''}\t`},`
      // for (const key in dataList?.err[i]) {
      //   if (key !== 'id') {
      //     str += `${`${dataList?.err[i][key]}\t`},`
      //   }
      // }
      str += '\n'
    }
    // encodeURIComponent解决中文乱码
    // eslint-disable-next-line prefer-template
    const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str)
    // 通过创建a标签实现
    const link = document.createElement('a')
    link.href = uri
    // 对下载的文件命名
    link.download = `${t('错误数据')}.csv`
    link.click()
  }
  return (
    <Container
      visible={visible}
      width={600}
      centered
      title={<SignTitle show>{t('批量导入')}</SignTitle>}
      maskClosable={false}
      footer={
        <Button
          type="primary"
          onClick={() => {
            closeModal(uploadSuccess)
          }}
        >
          {uploadSuccess ? t('确定') : t('取消')}
        </Button>
      }
      onCancel={closeModal}
      afterClose={() => {
        setUploadSuccess(false)
        setDataList({})
        setErr(false)
        setUploadCsvLoading(false)
        setSwitchVal(true)
      }}
    >
      {uploadSuccess ? (
        <div>
          <ResultContainer>
            <IconFont type={'icon-chenggong2'} className="icon" />
            <div className="result" style={{ margin: '40px 0' }}>
              {t('导入成功')}
            </div>
            <div className="content-container">
              <div className="content">
                <div>{t('变更数据')}</div>
                <div>
                  <span className="num">{dataList?.update_count || 0}</span>
                  {t('条')}
                </div>
              </div>
              <div className="content">
                <div>{t('错误数据')}</div>
                <div>
                  <span className="num-err">{dataList?.err_count || 0}</span>
                  {t('条')}
                </div>
                <Button
                  disabled={!(dataList.err_count > 0)}
                  onClick={() => {
                    tableToExcel()
                  }}
                >
                  {t('下载')}
                </Button>
              </div>
              <div className="content">
                <div>{t('重复数据')}</div>
                <div>
                  <span className="num">{dataList?.repeated_count || 0}</span>
                  {t('条')}
                </div>
              </div>
            </div>
          </ResultContainer>
        </div>
      ) : (
        <>
          <div>
            {t('将变更的数据覆盖：')}
            <Switch checked={switchVal} onChange={setSwitchVal} />
          </div>
          <div style={{ width: 536, height: 196, marginTop: 27 }}>
            <UpLoadFile
              showUploadList={false}
              disabled={uploadCsvLoading}
              className={err && 'err'}
              headers={{
                'user-id': userData.id,
                token: userData.token,
              }}
              action={`${
                process.env.NODE_ENV === 'dev' ? '/api' : ''
              }/portal/verify/phish/contacts/loadcsv`}
              beforeUpload={file => {
                const reg = /\.csv$/
                if (reg.test(file.name)) {
                  return true
                }
                setErr(true)
                Message.error(t('仅支持上传.csv文件'))
                return false
              }}
              onChange={({ file }) => {
                if (file.status === 'uploading') {
                  setUploadCsvLoading(true)
                  return
                }
                if (
                  file.status === 'done' ||
                  file.status === 'error' ||
                  file.status === 'success'
                ) {
                  setUploadCsvLoading(false)
                }
                if (file.status === 'done') {
                  const { code, msg } = file.response
                  if (code === 200) {
                    setErr(false)
                    setDataList(file.response.data)
                    setUploadSuccess(true)
                    // getEmailList$.emit()
                    // setSteps(2)
                  } else {
                    setErr(true)
                    Message.error(msg || t('上传失败'))
                  }
                  return
                }
                if (file.status === 'error') {
                  setErr(true)
                  Message.error(t('上传失败'))
                }
              }}
              data={{
                is_overwrite: switchVal,
              }}
              name={'file_name'}
              maxCount={1}
              text={
                uploadCsvLoading ? (
                  t('上传中,请稍后')
                ) : (
                  <div style={{ color: '#666' }}>
                    <span style={{ color: err ? '#f5222d' : '#666' }}>
                      {t('将文件拖拽到此处,或')}
                    </span>
                    <Typography.Link style={{ color: '#4238c9' }}>
                      <u>{t('点击上传')}</u>
                    </Typography.Link>
                    <div style={{ marginTop: 12 }}>
                      {t('支持上传CSV格式（UTF-8、GB2312），文件不超过10M')}
                    </div>
                  </div>
                )
              }
            />
          </div>
          <DownloadCSV>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${
                process.env.NODE_ENV === 'dev' ? '/api' : ''
              }/portal/verify/phish/contacts/template`}
            >
              <IconFont style={{ color: '#031A79' }} type="icon-xiangmuwenjianmobanku_mobanku" />
              {t('下载CSV模板')}
            </a>
          </DownloadCSV>
        </>
      )}
    </Container>
  )
}

const Container = styled(Modal)``
const DownloadCSV = styled.div`
  margin-top: 20px;
`

const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
  .icon {
    font-size: 54px;
  }
  .result {
    margin: 5px 0;
    margin-top: 10px;
    font-size: 24px;
    //font-family: 500;
  }
  .text {
    color: #666;
    line-height: 1.2;
  }
  .content-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .content {
    width: 168px;
    height: 152px;
    background: #f7f8f9;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      margin-bottom: 12px;
    }
  }
  .num {
    font-weight: bold;
    font-size: 18px;
    color: #558492;
  }
  .num-err {
    font-weight: bold;
    font-size: 18px;
    color: #f53f3f;
  }
`
